export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly detail?: { detail?: string; title?: string },
  ) {
    super(detail?.detail ?? detail?.title ?? `Request failed (${status})`);
    this.name = "ApiError";
  }
}
